import { type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { Nav } from "../Nav/Nav";
import { Footer } from "../Footer/Footer";
import { Blobs } from "../Blobs/Blobs";
import { SyntaxBg } from "../SyntaxBg/SyntaxBg";
import type { Theme } from "../../types";
import styles from "./PageShell.module.scss";

interface PageShellProps {
  theme: Theme;
  children: ReactNode;
  blobs?: boolean;
  syntax?: boolean;
}

export function PageShell({
  theme,
  children,
  blobs = true,
  syntax = true,
}: PageShellProps) {
  const location = useLocation();
  const gridUrl = `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32'><path d='M32 0H0V32' fill='none' stroke='${encodeURIComponent(theme.rule)}' stroke-width='1'/></svg>")`;

  return (
    <div
      className={styles.backdrop}
      style={{
        background: theme.bg,
        color: theme.fg,
        backgroundImage: gridUrl,
      }}
    >
      {blobs && <Blobs theme={theme} />}
      {syntax && <SyntaxBg theme={theme} />}
      <div className={styles.layer}>
        <Nav theme={theme} />
        <main key={location.pathname} className={styles.main}>
          {children}
        </main>
        <Footer theme={theme} />
      </div>
    </div>
  );
}
